import { render } from "./NavPlantsSidebar.vue?vue&type=template&id=19fced86"
import script from "./NavPlantsSidebar.vue?vue&type=script&lang=js"
export * from "./NavPlantsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__